<ng-container>
  <div class="notification__image-wrapper">
    <pp-icon class="notification__image" [ppSrc]="EIconPath.NOTIFICATION_ICON_FILE" ppColor="primary-950"></pp-icon>
  </div>

  @if (isNewValue) {
    <span class="notification__blue-text">{{ 'added' | ppTranslate }}</span>
    @if (addedSingleFile) {
      {{ 'a' | ppTranslate }}
      <span class="notification__bold">{{ 'file_uppercase' | ppTranslate }}</span>
    }
    @if (addedMultipleFiles) {
      {{
      ppNotification.changeBody.oldValue
      ? ppNotification.changeBody.newValue.length - ppNotification.changeBody.oldValue.length
      : ppNotification.changeBody.newValue.length
      }}
      <span class="notification__bold">{{ 'files_uppercase' | ppTranslate }}</span>
    }
    {{ 'to_a_point_you' | ppTranslate }}
    {{ notificationReason }}.
  }

  @if (!isNewValue) {
    <span class="notification__blue-text">{{ 'removed' | ppTranslate }}</span>
    @if (removedSingleFile) {
      {{ 'a' | ppTranslate }}
      <span class="notification__bold">{{ 'file_uppercase' | ppTranslate }}</span>
    }
    @if (removedMultipleFiles) {
      {{
      ppNotification.changeBody.oldValue
      ? ppNotification.changeBody.newValue.length - ppNotification.changeBody.oldValue.length
      : ppNotification.changeBody.newValue.length
      }}
      <span class="notification__bold">{{ 'files_uppercase' | ppTranslate }}</span>
    }
    {{ 'from_a_point_you' | ppTranslate }}
    {{ notificationReason }}.
  }
</ng-container>
